import { TagProps } from 'antd';

export const CERTIFICATE_STATUS_MAP: Record<
  string,
  { text: string; color: TagProps['color'] }
> = {
  pending: { text: 'Pendente', color: 'orange' },
  ready_for_issuance: { text: 'Apto para emissão', color: 'purple' },
  pending_regulatory_review: { text: 'Aguardando reguladora', color: 'blue' },
  issued: { text: 'Emitido', color: 'green' },
  approved: { text: 'Aprovado para emissão', color: 'green' },
  processing: { text: 'Em processamento', color: 'blue' },
  rejected: { text: 'Rejeitado', color: 'red' }
};
